<!-- <template>
  <span>asdasd</span>
</template> -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="期间">
              <global-select
                :focusGet="true"
                ref="rangPicker"
                @change="handlerRangPicker"
                :value.sync="monthTem"
                selectType="selectSearch"
                requestApi="/scp/scpMpsBasicData/monthList"
                searchParam="inputString"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpMpsBasicData:add']">新增</a-button>
      <!-- <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomConversions:export']">导出</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.BASIC_INFO_INDEX_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="month" slot-scope="{ record }">
            <span>{{ record.monthStart+"~"+record.monthEnd }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="versionCode" slot-scope="{ record }">
            <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="handleDelete(typeList, record)" v-hasPermi="['scp:scpMpsBasicData:remove']">删除</a>
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

      <script>
      import { apiScpMpsBasicDataList, apiDelScpMpsBasicData } from '@/api/mps/basic-data/basic-data.js'
      import CreateForm from './components/CreateForm'

      import { generateLsTableResData } from '@/utils/util.js';
      export default {
        // eslint-disable-next-line
        name: 'Basic-info-index',
        components: {
          CreateForm
        },
        data () {
          return {
            monthTem: '',
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiScpMpsBasicDataList, true),
              pageCurrent: true
            },
            isEdit: false,
            currentId: "",
            // 控制搜索展开
            advanced: true,
            // 查询参数
            queryParams: {
              monthTem: undefined,
              monthStart: '',
              monthEnd: '',
              versionCode: ''
            },
            mode: ['month', 'month'],
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 状态快码
            statusOptions: [
              {
                dictLabel: "有效",
                dictValue: "Y"
              },
              {
                dictLabel: "无效",
                dictValue: "N"
              }
            ],
            baseUomFlagOptions: [
              {
                dictLabel: "是",
                dictValue: "Y"
              },
              {
                dictLabel: "否",
                dictValue: "N"
              }
            ],
            // 表格字段
            columns: [
              {
                title: '期间',
                dataIndex: 'month',
                scopedSlots: { customRender: 'month' },
                width: 120,
                align: 'center'
              },
              {
                title: '版本',
                dataIndex: 'versionCode',
                scopedSlots: { customRender: 'versionCode' },
                width: 100,
                align: 'center'
              },
              {
                title: '说明',
                dataIndex: 'description',
                width: 120,
                align: 'left'
              },
              {
                title: '创建人',
                dataIndex: 'createName',
                width: 100,
                align: 'center'
              },
              {
                title: '创建时间',
                dataIndex: 'createTime',
                scopedSlots: { customRender: 'createTime' },
                width: 100,
                align: 'center'
              },
              {
                title: '操作',
                stickyFixed: 'right',
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' },
                width: 100,
                align: 'center'
              }
            ],
            uomClassOptions: [],
            unitOfMeasureList: [],
            unitOfMeasureListNew: []
          }
        },
        created () {
          // this.getUnitOfMeasureList()
          const lookupQueryParams = {
            lookupType: 'MDM_UOM_CLASSES',
            current: 1,
            pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this.uomClassOptions = response.rows
          })
        },
        mounted () {
         // this.onSearch()
        },
        methods: {
            handleDelete (arr, record) {
              const self = this
                this.$confirm({
                title: '警告',
                content: `真的要删除该项的数据项吗?`,
                okText: '删除',
                okType: 'danger',
                cancelText: '取消',
                onOk () {
                  apiDelScpMpsBasicData(record.id).then(response => {
                    if (response.code === 200) {
                      self.$message.success('删除成功')
                      self.onSearch()
                      self.isEdit = false;
                    } else {
                      self.$message.error(response.msg)
                    }
                  })
                }
              })
            },
          handlerRangPicker (val, selectList) {
            const filteredItem = selectList.filter(item => item.selectedValue === val);
        // const [startStr, endStr] = val.split('-');
          this.queryParams.monthStart = filteredItem[0].label;
          this.queryParams.monthEnd = filteredItem[0].realValue;
          },
          handleGoVersion (record) {
            this.$router.push({ path: `/basic-info-index/detail?id=${record.id}&description=${record.description}&versionCode=${record.versionCode}` })
          },
            handlePanelChange (value, mode) {
              const yearMonth1 = value[0].format('YYYYMM')
              const yearMonth2 = value[1].format('YYYYMM')
              this.queryParams.monthStart = yearMonth1
              this.queryParams.monthEnd = yearMonth2
              this.monthTem = value
            },
          blur (record) {
            if (!record.conversionRate || Number(record.conversionRate) <= 0) {
              this.$message.warning('折换不能为空且需大于0')
            } else {
              record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
            }
          },
          statusOnChange (record) {
            record.status = record.status === 'Y' ? 'N' : 'Y'
          },
          // 导入导出excel
          /** 导出按钮操作 */
          handleExport () {
            this.download('mdm/mdmUomConversions/export', {
              ...this.queryParams
            }, `标准单位转换_${new Date().getTime()}.xlsx`)
          },
          // 编辑
          handleEdit (record) {
            if (this.currentId && record.id !== this.currentId && this.isEdit) {
              this.$message.warning('请保存上次编辑的数据')
              return;
            }
            this.isEdit = true;
            this.currentId = record.id;
          },
          // 编辑-保存
          // handleSave (record) {
          //   if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          //     this.$message.warning('折换不能为空且需大于0')
          //     return
          //   }
          //   updateUnit(record).then(response => {
          //     if (response.code === 200) {
          //       this.$message.success('保存成功')
          //       this.onSearch()
          //       this.isEdit = false;
          //     } else {
          //       this.$message.error(response.msg)
          //     }
          //   })
          // },
          // 取消
          handleCancel (record) {
            this.isEdit = false
            this.onSearch()
          },
          // 新增/修改框事件
          handleOk () {
             this.onSearch()
          },
          // 表单搜索
          onSearch () {
            // if (!this.monthTem) {
            //  this.$message.error('期间选项不能为空')
            //  return
            // }
            // if (!this.queryParams.versionCode) {
            //   this.$message.error('版本不能为空')
            //   return
            // }
            this.isEdit = false
            this.$refs.dataTable.searchParams = this.queryParams;
            this.$refs.dataTable.getData();
          },
          /** 重置按钮操作 */
          resetQuery () {
            this.queryParams = {
              monthTem: undefined,
              monthStart: '',
              monthEnd: '',
              versionCode: ''
            }
            this.monthTem = undefined
            this.onSearch()
          },
          // 搜索框展开、收起
          toggleAdvanced () {
            this.advanced = !this.advanced
          }
        }
      }
      </script>

      <style scoped lang="less">
      .ml10{
        margin-left: 10px;
      }
      </style>
